import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface NotificationIconProps extends SvgIconProps {}

export const NotificationIcon = ({
  style,
  ...iconProps
}: NotificationIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="15"
      height="20"
      viewBox="0 0 15 20"
    >
      <path
        d="M0 16.3845V14.8848H1.80775V7.423C1.80775 6.07817 2.22283 4.88908 3.053 3.85575C3.883 2.82242 4.94867 2.1615 6.25 1.873V1.25C6.25 0.902833 6.37142 0.607667 6.61425 0.3645C6.85708 0.1215 7.15192 0 7.49875 0C7.84575 0 8.141 0.1215 8.3845 0.3645C8.62817 0.607667 8.75 0.902833 8.75 1.25V1.873C10.0513 2.1615 11.117 2.82242 11.947 3.85575C12.7772 4.88908 13.1923 6.07817 13.1923 7.423V14.8848H15V16.3845H0ZM7.49825 19.1923C7.00075 19.1923 6.57542 19.0153 6.22225 18.6613C5.86892 18.3073 5.69225 17.8817 5.69225 17.3845H9.30775C9.30775 17.8833 9.13058 18.3093 8.77625 18.6625C8.42192 19.0157 7.99592 19.1923 7.49825 19.1923ZM3.30775 14.8848H11.6923V7.423C11.6923 6.26533 11.283 5.27725 10.4645 4.45875C9.64583 3.64008 8.65767 3.23075 7.5 3.23075C6.34233 3.23075 5.35417 3.64008 4.5355 4.45875C3.717 5.27725 3.30775 6.26533 3.30775 7.423V14.8848Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
